import React, { useCallback, useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import type { FC, ChangeEvent } from "react";

import { useStyles } from "./VirtualFrequencyControl.styles";
import { getFrequencyName } from "./VirtualFrequencyControl.utils";
import type { IVirtualFrequencyProps, VirtualFrequencyValue } from "./VirtualFrequencyControl.types";

import { useBulkExportContext } from "../../../../../../providers";
import { IDimension } from "../../../../../../types";

export const VirtualFrequencyControl: FC<IVirtualFrequencyProps> = (props) => {
  const classes = useStyles();
  const { selection, onChange, availableFrequencies } = props;
  const [value = availableFrequencies[0]] = selection;
  const context = useBulkExportContext();

  const dimensions: IDimension[] = context?.state.dimensions || [];

  const handleChange = useCallback(
    (e: ChangeEvent<{}>, value: string) => {
      onChange?.([Number(value)]);
    },
    [onChange]
  );

  useEffect(() => {
    if (selection.length === 0 && onChange && dimensions.length !== 0) {
      const dateRange: VirtualFrequencyValue | undefined = dimensions
        .find((d) => d.id === "calendar.default")
        ?.selection[0]?.toString()
        ?.split("")
        .map(Number)[0];

      if (dateRange && availableFrequencies.includes(dateRange)) {
        onChange([dateRange]);
      } else {
        onChange([availableFrequencies[0]]);
      }
    }
  }, [selection, availableFrequencies, dimensions, onChange]);

  return (
    <FormControl component="fieldset" className={classes.root}>
      <RadioGroup
        className={classes.group}
        row
        aria-label="position"
        name="position"
        value={String(value)}
        defaultValue={String(value)}
        onChange={handleChange}
      >
        {availableFrequencies.map((frequency) => (
          <FormControlLabel
            key={frequency}
            className={classes.controlLabel}
            value={String(frequency)}
            control={<Radio color="primary" className={classes.control} />}
            label={getFrequencyName(frequency)}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
